/**
 * Frontend Routes
 * Route paths for React Router
 */

export const ROUTES = {
  // Public Routes
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",

  // Protected Routes
  DASHBOARD: "/dashboard",
  SETTINGS: "/settings",
  JOBS: "/jobs",
  JOB_DETAILS: (jobId: string) => `/jobs/${jobId}`,
  CREATE_JOB: "/create-job",
  CHAT: "/chat",
  LIVE_DEMO: "/live-demo",
  PROFILE: "/profile",

  // Admin Routes
  ADMIN: "/admin",
  ADMIN_DASHBOARD: "/admin",
  ADMIN_USERS: "/admin/users",
  ADMIN_JOBS: "/admin/jobs",
  ADMIN_CHATS: "/admin/chats",

  // Other
  NOT_FOUND: "/404",
} as const;

// Navigation Items
export interface NavItem {
  label: string;
  path: string;
  emoji: string;
  requireAuth: boolean;
  adminOnly?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: "Home",
    path: ROUTES.HOME,
    emoji: "🏠",
    requireAuth: false,
  },
  {
    label: "Dashboard",
    path: ROUTES.DASHBOARD,
    emoji: "📊",
    requireAuth: true,
  },
  {
    label: "Jobs",
    path: ROUTES.JOBS,
    emoji: "💼",
    requireAuth: true,
  },
  {
    label: "Create Job",
    path: ROUTES.CREATE_JOB,
    emoji: "➕",
    requireAuth: true,
  },
  {
    label: "Admin",
    path: ROUTES.ADMIN_DASHBOARD,
    emoji: "🔐",
    requireAuth: true,
    adminOnly: true,
  },
];
